<script>
export const group = 'Full'
</script>

<script setup>
import DefaultDarioPancarte from '../default/DarioPancarte.vue'
import { ref, nextTick } from 'vue'
import Transition4 from './transitions/Transition4.vue'

defineProps({
  item: Object,
})

const transition = ref(null)

const startTransition = async () => {
  await nextTick()
  if (transition.value) {
    transition.value.start()
  }
}
</script>

<template>
  <Transition4 ref="transition" :manualStart="true">
    <DefaultDarioPancarte :item="item" :fade="false" @loaded="startTransition" />
  </Transition4>
</template>
